import Api from "@/api";

export const useUpdateContributor = Api.projects.useUpdateContributor;
export const useAddProjectContributor = Api.projects.useCreateContributor;
